import { groupMarketsBySport, filterMarkets, filterOutrightsMarkets, prepareOutrightMarkets } from "../../helpers";
export const prepareMarkets = (markets, cardConfig, specialLeagues, allEvents, outrightSelectionSorter) => {
    const marketsF = []; //TODO: Rename to something meaningful
    // 1. Filter outrights
    const outrightsMarkets = prepareOutrightMarkets(markets, allEvents, outrightSelectionSorter);
    // 2. Group markets by sport and store them in an object
    const regularMarkets = filterOutrightsMarkets(false, markets, allEvents);
    // 3. Fill empty selections for each sport
    const marketsBySport = filterMarkets(groupMarketsBySport(regularMarkets, cardConfig), cardConfig, specialLeagues);
    // 4. Fill prepared markets into array
    Object.keys(marketsBySport).forEach(key => {
        marketsBySport[key].length && marketsF.push(...marketsBySport[key]);
    });
    return [...marketsF, ...outrightsMarkets];
};
//# sourceMappingURL=prepareMarkets.js.map